import React from 'react';

import { Box, FormControlLabel, lighten, Radio } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { FormattedMessage } from 'react-intl';

interface ControlRadioBoxProps {
    formValue: string;
    label: string;
    translation: string;
    defaultMessage: string;
    onChange?: (value: string) => void;
}
const ControlRadioBox = ({
    formValue,
    label,
    translation,
    defaultMessage,
    onChange,
}: ControlRadioBoxProps) => {
    const { theme } = useTheme();
    return (
        <Box
            onClick={() => onChange(label)}
            sx={{
                backgroundColor:
                    formValue === label
                        ? theme.palette.mode === 'dark'
                            ? theme?.palette?.primary.main
                            : lighten(theme.palette.primary.main, 0.85)
                        : 'inherit',
                borderWidth: 1,
                borderColor: theme?.palette.grey[200],
                borderStyle: 'solid',
                borderRadius: 0.5,
                mb: 2,
            }}>
            <FormControlLabel
                value={label}
                control={
                    <Radio
                        checked={formValue === label}
                        sx={{
                            color:
                                theme.palette?.mode === 'dark'
                                    ? theme?.palette?.primary?.contrastText
                                    : 'inherit',
                            '&.Mui-checked': {
                                color:
                                    theme.palette?.mode === 'dark'
                                        ? theme?.palette?.primary?.contrastText
                                        : theme?.palette?.primary?.main,
                            },
                        }}
                        data-testid={`${label}-type-radio`}
                    />
                }
                label={
                    <FormattedMessage
                        id={translation}
                        defaultMessage={defaultMessage}
                    />
                }
                sx={{ ml: 1, p: 0.5 }}
            />
        </Box>
    );
};

export default ControlRadioBox;
